<template>
  <div id="app" class="app" :class="$route.path === '/login' ? '' : 'minwidth'">
    <div class="tools">
      <div v-if="0" @mouseover="showCode(1)" @mouseleave="hideCode">
        <img :src="wx" alt="">
        <div>微信沟通</div>
        <div v-show="curIndex === 1" class="code">
          
        </div>
      </div>
      <div @mouseover="showCode(2)" @mouseleave="hideCode">
        <img :src="gzh" alt="">
        <div>微信</div>
        <div v-show="curIndex === 2"  class="code">
          <img id="img_wx" :src="gzh_code" alt="">
          <div>打开微信，扫码沟通</div>
        </div>
      </div>
      <div @mouseover="showCode(3)" @mouseleave="hideCode">
        <img :src="qq" alt="">
        <div>QQ</div>
        <div v-show="curIndex === 3"  class="code_qq">
          <img id="img_qq" :src="qq_code" alt="">
          <div>打开qq扫一扫</div>
        </div>
      </div>
      <div @click="toTop">
        <img :src="up" alt="">
      </div>
    </div>
    <div v-if="$route.path !== '/login'" class="container">
      <div class="header" :class="$route.path === '/price' ||  $route.path === '/update' ? 'price-header' : (changeHeader ? 'header-change' : '')">
        <div class="header-main">
          <!-- logo -->
          <div class="logo">
            <h1></h1>
          </div>
          <div class="logOut">
            <span v-if="token" class="info">{{info}}</span>
            <span v-if="token" @click="quit" class="quit">退出</span>
          </div>
          <div class="menu">
            <div class="popu" @mouseover="over"  @mouseout="showPop = false" v-show="showPop">
              <div class="arrow"></div>
              <ul v-for="(item,index) in menu" :key="index">
                <li><span>{{item.title}}</span></li>
                <li v-for="(detail,detailIndex) in item.list" :key="detailIndex">
                  <div :class="curProduct === detail.name ? 'product-title' : ''" @click="toDetail(detail)">{{detail.title}}</div>
                  <div>{{detail.intro}}</div>
                </li>
              </ul>
            </div>
            <!-- 头部菜单 -->
            <el-menu :default-active="$route.path" :router="true" class="el-menu-main" mode="horizontal" @select="handleSelect">
              <el-menu-item @mouseover.native="showPop = false" index="/">首页</el-menu-item>
              <el-menu-item 
                class="all-product" 
                :class="(showPop || isHas) ? 'is-active' : ''" 
                @mouseover.native="over" 
                @mouseout.native="leave" 
                index="/tiku">
                  所有产品 <i class="el-icon-arrow-down"></i>
              </el-menu-item>
              <el-menu-item @mouseover.native="showPop = false" index="/download">软件下载</el-menu-item>
              <el-menu-item @mouseover.native="showPop = false" index="/course">在线教程</el-menu-item>
              <el-menu-item @mouseover.native="showPop = false" index="/price">产品价格</el-menu-item>
              <el-menu-item @mouseover.native="showPop = false" index="/anli">客户案例</el-menu-item>
              <el-menu-item @mouseover.native="showPop = false" index="/about">关于我们</el-menu-item>
            </el-menu>
            <!-- 头部右侧按钮 -->
            <el-button v-if="!token" type="success" size="mini" class="login-btn" @click="login" round>登录</el-button>
            <el-button v-if="!token" type="warning" size="mini" class="reg-btn" @click="reg" round>注册</el-button>
            
          </div>
          
        </div>
      </div>
      <div class="main">
        <div class="content">
          <router-view/>
        </div>
      </div>
      <!-- 底部 -->
      <div class="footer">
        <div class="menu">
          <ul>
            <li>
              <img :src="logo" alt="">
            </li>
            <li>徐州乐分享软件科技有限公司</li>
            <li>18652255099</li>
            <li>地址：徐州市中国矿业大学国家大学科技园</li>
          </ul>
          <ul>
            <li>关于我们</li>
            <li><a href="javascript:;" @click="$router.push({ name: 'About'})">公司概况</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'About'})">发展状况</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'About'})">联系我们</a></li>
            <li><a href="javascript:;" @click="toReg">乐分享软件  注册使用协议</a></li>
            <li><a href="javascript:;" @click="toSecret">隐私声明</a></li>
            <li><a href="javascript:;" @click="toRelief">版权及免责声明</a></li>
          </ul>
          <ul>
            <li>所有产品</li>
            <li><a href="javascript:;" @click="$router.push({ name: 'CSDetail'})">乐分享题库系统 · 个人版</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Tiku'})">乐分享题库系统 · 网页版</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'CSDetail'})">乐分享题库系统 · 网络客户端版</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'OnlineDetail'})">乐分享在线考试系统</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Word'})">Word批量处理大师</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Ppt'})">PPT批量处理大师</a></li>
            <!-- <li><a href="javascript:;">Excel批量处理大师</a></li>
            <li><a href="javascript:;">PDF批量处理大师</a></li> -->
          </ul>
          <ul>
            <li>在线教程</li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Course'})">软件使用</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Course'})">功能操作</a></li>
          </ul>
          <ul>
            <li>软件下载</li>
            <!-- <li><a href="javascript:;">软件介绍</a></li>
            <li><a href="javascript:;">软件详情</a></li> -->
            <li><a href="javascript:;" @click="$router.push({ name: 'Download'})">软件下载</a></li>
            <li><a href="javascript:;" @click="$router.push({ name: 'Update'})">更新信息</a></li>
          </ul>
          <ul class="code">
            <li class="erweima">
              <img :src="gzh_code" alt="">
            </li>
            <li>关注我们</li>
          </ul>
        </div>
        <div class="beian">
          <div>徐州乐分享软件科技有限公司 | CopyRight   2006-2021   乐享软件</div>
          <div>
            备案号
            <a :href="beianUrl" target="_blank">{{beian}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="login-main" v-else>
      <router-view/>
    </div>
  </div>
</template>
<script>
import { logOut } from '@/api'
export default {
  data(){
    return {
      beian: IPConfig.beian,
      beianUrl: IPConfig.beianUrl,
      wx: require('@/assets/icon_wx.png'),
      // gzh: require('@/assets/icon_gzh.png'),
      // gzh_code: require('@/assets/gzh.jpg'),
      gzh: require('@/assets/icon_weixin.png'),
      gzh_code: require('@/assets/wx.png'),
      qq: require('@/assets/icon_qq.png'),
      qq_code: require('@/assets/qq.png'),
      up: require('@/assets/icon_up.png'),
      curIndex: -1,
      changeHeader: false,
      logo: require('@/assets/logo@2x.png'),
      timer: '',
      showPop: false,
      curProduct: '',
      token: '',
      info: '', // 用户信息
      menu: [
        {
          title: '题库系统',
          list: [
            {
              title: '乐分享题库系统 · 网页版',
              intro: '快速入库、全兼容Word',
              name: 'Tiku'
            },
            {
              title: '乐分享题库系统 · 个人版',
              intro: '快速入库，建立错题本',
              name: 'Personal'
            },
            {
              title: '乐分享题库系统 · 网络客户端版',
              intro: '快速建立题库，全兼容，防作弊',
              name: 'CSDetail'
            }
          ]
        },
        {
          title: '考试系统',
          list: [
            {
              title: '乐分享在线考试系统',
              intro: '跨平台、多方位的考试系统',
              name: 'OnlineDetail'
            }
          ]
        },
        {
          title: 'Office处理',
          list: [
            {
              title: 'Word批量超级大师',
              intro: 'Word内容、格式、图片等批量处理',
              name: 'Word'
            },
            {
              title: 'PPT批量处理大师',
              intro: '批量运行，格式转换',
              name: 'Ppt'
            },
          ]
        }
      ]
    }
  },
  computed: {
    isHas(){
      var isHas = false;
      this.menu.forEach(item => {
        item.list.forEach(detail => {
          if(detail.name === this.curProduct){
            isHas = true;
          }
        })
      })
      return isHas;
    }
  },
  watch: {
    '$route': {
      handler(newV){
        this.curProduct = newV.name;
        this.info = localStorage.getItem('user');
        this.token = localStorage.getItem('token');
      },
      deep: true,
      immediate: true
    }
  },
  mounted(){
    window.addEventListener('scroll',() => {
      if(this.$route.path !== '/price' && this.$route.path !== '/update'){
        if(window.scrollY > 100){
          this.changeHeader = true;
        }else{
          this.changeHeader = false;
        }
      }else{
        this.changeHeader = false;
      }
    })
  },
  methods: {
    toReg(){
      const url = this.$router.resolve({name: 'RegAgree'})
      window.open(url.href,'_blank')
    },
    toSecret(){
      const url = this.$router.resolve({name: 'Secret'})
      window.open(url.href,'_blank')
    },
    toRelief(){
      const url = this.$router.resolve({name: 'Relief'})
      window.open(url.href,'_blank')
    },
    //退出
    quit(){
      logOut({
        type_src: 0, //0-官网；1-题库Web端；2-题库组卷微信小程序；3-后台管理；4-考试（同一时间仅限登录一个考试端）；5-网络版客户端
      }).then(data => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.$router.push({
          name: 'Login'
        })
      })
    },
    showCode(index){
      this.curIndex = index;
    },
    hideCode(){
      this.curIndex = -1;
    },
    toTop(){
      document.body.scrollIntoView({
        behavior: 'smooth'
      })
    },
    leave(){
      this.timer = setTimeout(() => {
        this.showPop = false;
      },500)
    },
    over(){
      clearTimeout(this.timer);
      this.showPop = true;
    },
    toDetail(obj){
      this.curProduct = obj.name;
      this.$router.push({
        name: obj.name
      })
    },
    handleSelect() {

    },
    login(){
      this.$router.push({
        name: 'Login'
      })
      localStorage.setItem('login',true);
      // this.$alert('抱歉！乐分享官网正在升级，登录和注册功能暂时不开放！', '提示', {
      //   confirmButtonText: '确定',
      //   lockScroll: false,
      //   callback: () => {
          
      //   }
      // });
    },
    reg(){
      this.$router.push({
        name: 'Login'
      })
      localStorage.setItem('login',false);
      // this.$alert('抱歉！乐分享官网正在升级，登录和注册功能暂时不开放！', '提示', {
      //   confirmButtonText: '确定',
      //   lockScroll: false,
      //   callback: () => {
          
      //   }
      // });
    }
  }
}
</script>
<style lang="less">
  body{
    margin: 0;
  }
  ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  h1{
    margin: 0;
  }
  img{
    vertical-align: top;
  }
  html,body{
    height: 100%;
  }
  .login-main{
    position: relative;
    height: 100%;
    background: url('./assets/login_bj.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .minwidth{
    min-width: 1200px;
  }
  #app{
    height: 100%;
    font-size: 16px;
    .tools{
      position: fixed;
      top: 55%;
      right: 20px;
      display: flex;
      flex-direction: column;
      z-index: 999;
      color: #fff;
      text-align: center;
      >div{
        width: 60px;
        height: 60px;
        padding-top: 10px;
        cursor: pointer;
        padding: 10px 5px 0px 5px;
        margin-bottom: 20px;
        background-color: #F88927;
        position: relative;
        img{
          width: 31px;
          height: 31px;
        }
        .code{
          position: absolute;
          width: 220px;
          height: 220px;
          // background: url('./assets/img_ewmbj.png') no-repeat center center;
          left: -200px;
          top: -100px;
          background-size: 100% 100%;
          color: #acacac;
          text-align: center;
          // img{
          //   margin-top: 16px;
          //   width: 170px;
          //   height: 170px;
          // }
          // img{
          //   margin-top: 16px;
          //   width: 190px;
          //   height: 260px;
          // }
          #img_wx{
            margin-top: 16px;
            width: 190px;
            height: 260px;
          }                   
        }
        .code_qq{
          position: absolute;
          width: 220px;
          height: 220px;
          // background: url('./assets/img_ewmbj.png') no-repeat center center;
          left: -370px;
          top: -100px;
          background-size: 100% 100%;
          color: #acacac;
          text-align: center;
          // img{
          //   margin-top: 16px;
          //   width: 170px;
          //   height: 170px;
          // }
          #img_qq{
            margin-top: 16px;
            width: 376px;
            height: 260px;
          }                   
        }
        
        
        &:nth-last-of-type(1){
          img{
            margin-top: 15px;
          }
        }
        &:nth-of-type(3){
          img{
            width: 30px;
            height: 17px;
          }
        }
      }
    }
    .container{
      min-width: 1200px;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .header{
      background-color: transparent;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      .header-main{
        min-width: 1120px;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        // overflow: hidden;
        .logOut{
          float: right;
          line-height: 60px;
          margin-right: 30px;
          font-size: 18px;
          color: #fff;
          .info{
            margin-right: 10px;
          }
          .quit{
            cursor: pointer;
            &:hover{
              color: #f88927;
            }
          }
          .active{
            color: #444444;
          }
        }
        .logo{
          float: left;
          height: 100%;
          h1{
            width: 193px;
            height: 60px;
            background: url('./assets/logo@2x.png') no-repeat center center;
            background-size: contain;
          }
        }
        .menu{
          float: right;
          padding-right: 10px;
          position: relative;
          // margin-right: 78px;
          .popu{
            position: absolute;
            top: 60px;
            left: 0;
            // width:770px;
            // height:280px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 16px 0px rgba(16,128,235,0.3);
            border-radius:4px;
            box-sizing: border-box;
            display: flex;
            padding: 20px 30px;
            z-index: 10;
            .arrow{
              position: absolute;
              top: -16px;
              left: 130px;
              width: 0;
              height: 0;
              border: 8px solid #fff;
              border-top-color: transparent;
              border-left-color: transparent;
              border-right-color: transparent;
            }
            ul{
              flex: 1;
              margin-right: 20px;
              li{
                &:nth-of-type(1){
                  color: #1B8CF7;
                  font-size: 20px;
                  span{
                    padding-right: 20px;
                    border-bottom: 1px solid rgba(239,239,239,1);
                    display: inline-block;
                    padding-bottom: 10px;
                  }
                }
                &:not(:nth-of-type(1)){
                  margin-top: 20px;
                }
                >div{
                  &:nth-of-type(1){
                    font-size: 16px;
                    color: #515151;
                    cursor: pointer;
                    &:hover{
                      color: #F88927;
                    }
                  }
                  &:nth-of-type(2){
                    font-size: 12px;
                    color: #AEAEAE;
                    margin-top: 5px;
                  }
                }
                .product-title{
                  color: #F88927!important;
                }
              }
            }
          }
          .el-menu{
            background-color: transparent;
          }
          .el-menu-main{
            background-color: transparent;
            border-bottom: none;
            vertical-align: middle;
            display: inline-block;
            margin-right: 5px;
            >.el-menu-item{
              color: #fff;
              font-size: 20px;
              &:not(.is-disabled):hover{
                color: #f88927;
                border-bottom: 2px solid #f88927;
                background-color: transparent;
              }
            }
            >.el-menu-item.is-active{
              color: #f88927;
              border-bottom: 2px solid #f88927!important;
              background-color: transparent;
            }
            >.el-menu-item:not(.is-disabled):focus{
              background-color: transparent;
            }
            .all-product{
              padding-right: 0;
              .el-icon-arrow-down{
                color: #fff;
              }
            }
            .all-product.is-active{
              .el-icon-arrow-down{
                color: #f88927;
              }
            }
          }
          .el-button{
            vertical-align: middle;
          }
        }
      }
    }
    .price-header{
      position: absolute!important;
    }
    .header-change{
      background-color: #fff;
      border-bottom: 1px solid #eee;
      .header-main .menu .el-menu-main > .el-menu-item{
        color: #444444;
      }
      h1{
        background: url('./assets/logo_black@2x.png') no-repeat center center!important;
        background-size: 193px 26px!important;
      }
      .header-main .menu .el-menu-main .all-product .el-icon-arrow-down{
        color: #444444;
      }
      .logOut{
        color: #444444!important;
      }
    }
    .main{
      flex: 1;
    }
    .content{
      overflow: hidden;
    }
    .footer{
      text-align: left;
      display: flex;
      flex-direction: column;
      color: #fff;
      background-color: #2D2D2D;
      padding-top: 40px;
      .menu{
        display: flex;
        justify-content: space-around;
        width: 1200px;
        margin: 0 auto;
        font-size: 16px;
        ul{
          li{
            margin-bottom: 8px;
            &:nth-of-type(1){
              font-weight: bold;
              font-size: 18px;
              margin-bottom: 20px;
            }
            a{
              text-decoration: none;
              color: #fff;
              &:hover{
                color: #f88927;
              }
            }
          }
          .erweima{
            width: 86px;
            height: 86px;
            background-color: white;
            img{
              width: 100%;
              height: 100%;
              vertical-align: top;
            }
          }
        }
        .code{
          li{
            &:nth-of-type(2){
              text-align: center;
            }
          }
        }
      }
      .beian{
        background-color: #2D2D2D;
        height: 68px;
        text-align: center;
        padding: 20px 0;
        color: #acacac;
        div{
          height: 34px;
          line-height: 34px;
          a{
            color: #409eff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .app{
    color: #444444;
    .el-button{
      background-color: #f88927;
    }
    .login-btn{
      background-color: #67c23a;
    }
    .reg-btn{
      background-color: #FEB72C!important;
      border-color: #FEB72C!important;
    }
  }
</style>
